import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Full-screen "we are under maintenance" page. Rendered by AppComponent over
 * the current route when MaintenanceService reports the API is unreachable
 * (503, or a CORS-blocked 503 surfacing as status 0).
 *
 * Refresh reloads the widget iframe only (widget.js sandbox has no
 * allow-top-navigation), which is exactly what we want.
 */
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MaintenanceComponent {
  // Overridable in specs: window.location.reload is not spy-able in Chrome.
  reload: () => void = () => window.location.reload();

  refresh(): void {
    this.reload();
  }
}
